import { SingleAlertType } from 'app/constants/singleAlertType'

export const getSingleAlertName = (
  alertType: SingleAlertType,
  translate: (string) => string,
): string => {
  const text: string = SingleAlertType[alertType]
  return translate(`singleAlertType.${text}`)
}
